
import { Paper, Stack, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect } from 'react';
import { getSettings } from '../../redux/store';
import { connect } from 'react-redux'
import { Settings } from '../../redux/entities';


function SettingsPanel(props) {
    const { settings, create, update, remove, fetchAll } = props;


    useEffect(() => {
        fetchAll();
    }, []);

    function handleChange(key, value) {
        console.log("trygin to update", settings, value)
        const updated = { id: key, value};
        update(updated).then(result => { console.log("updated", result.payload)});
    }

    function getSetting(key) {
        const s = settings.find( s => (s.id === key));
        return s ? s.value : '';
    }

    return (
        <Box>
            <Paper>
                <Stack>
                    <Typography variant="body2">Default label numbering</Typography>
                    <Typography variant="body2">Default paper size</Typography>
                    <TextField value={getSetting('defaultPaper')} onChange={e => { handleChange('defaultPaper', e.target.value )}}/>

                    <Typography variant="body2">Default mini orientation: { getSetting('defaultOrientation') }</Typography>
                    <TextField value={getSetting('defaultOrientation')} onChange={e => { handleChange('defaultOrientation', e.target.value )}}/>
                </Stack>
            </Paper>
        </Box>
    )
}

function mapStateToProps(state) {
    const settings = getSettings(state);
    console.log("Settings loaded", settings)
    return { settings };
};



export default connect(mapStateToProps, {
    update: Settings.actions.updateEntityAsync,
    create: Settings.actions.createEntityAsync,
    remove: Settings.actions.removeEntityAsync,
    fetchAll: Settings.actions.fetchAllEntities,
})(SettingsPanel)
